export default __webpack_public_path__ + "static/media/f63f166ed01f503edc8a353d525775e8.svg";